import React from 'react';

import s from './styles.module.scss';

interface IProps {
  color: string;
  name: string;
  width?: string;
  height?: string;
}

export const ChartsLegendItem: React.FC<IProps> = ({
  color,
  name,
  width = '16px',
  height = '16px',
}) => {
  return (
    <div className={s.wrapper}>
      <span className={s.color} style={{ background: color, width, height }} />
      {name}
    </div>
  );
};
